<template>
  <div></div>
</template>

<script>

import {SET_INVITE_CODES} from "../../store/mutationTypes";
import {parseInviteCodesFromUri} from "../../utils";

export default {
  name: "InviteCodeRecorder",
  methods: {
    async getInvitedMembershipTypes (codes) {
      return this.$store.dispatch('listMembershipTypes', {inviteCodes: codes})
    },
  },
  mounted() {
    const codes = parseInviteCodesFromUri(this.$route.params.codes);

    this.getInvitedMembershipTypes(codes).then(membershipTypes => {
      if (membershipTypes.length>0) {
        this.$store.commit(SET_INVITE_CODES, codes)
      } else {
        this.$store.commit(SET_INVITE_CODES, null)
      }
      if (this.$store.getters.isLoggedIn) {
        this.$router.push('/')
      } else {
        this.$router.push('/signup')
      }
    });
  }
}
</script>

<style scoped>

</style>